'use es6';

let defaultNode = null;
export const setDefaultNode = node => {
  defaultNode = node;
};
export const getDefaultNode = () => {
  return defaultNode || document.body;
};